import AsyncJobsTable from './AsyncJobsTable';

export default AsyncJobsTable;


// WEBPACK FOOTER //
// ./src/features/organization/pages/async-jobs/async-jobs-table/index.js